export const NAV = {
  dashboard: "nav-dashboard",
  inquiries: "nav-inquiries",
  pipeline: "nav-pipeline",
  products: "nav-products",
  match: "nav-match",
  reports: "nav-reports",
  logout: "nav-logout",
};

export const LOGIN_PAGE = {
  googleButton: "login-google-button",
};

export const DASH = {
  cardToday: "dash-card-today",
  cardResponse: "dash-card-response",
  cardConversion: "dash-card-conversion",
  cardFollowups: "dash-card-followups",
  chartFabrics: "dash-chart-fabrics",
  chartChannels: "dash-chart-channels",
  followupsList: "dash-followups-list",
};

export const INQUIRY = {
  addButton: "inquiry-add-button",
  table: "inquiry-table",
  row: (id) => `inquiry-row-${id}`,
  rowOpen: (id) => `inquiry-open-${id}`,
  rowCheckbox: (id) => `inquiry-checkbox-${id}`,
  filterStatus: "inquiry-filter-status",
  filterChannel: "inquiry-filter-channel",
  detailDialog: "inquiry-detail-dialog",
  aiReplyText: "inquiry-ai-reply-text",
  aiReplyGenerate: "inquiry-ai-reply-generate",
  aiReplyLanguage: "inquiry-ai-reply-language",
  aiReplyMarkSent: "inquiry-ai-reply-mark-sent",
  aiReplySendManychat: "inquiry-ai-reply-send-manychat",
  statusSelect: "inquiry-status-select",
  createDialog: "inquiry-create-dialog",
  createNameInput: "inquiry-create-name-input",
  createPhoneInput: "inquiry-create-phone-input",
  createChannel: "inquiry-create-channel",
  createMessage: "inquiry-create-message",
  createSubmit: "inquiry-create-submit",
  bulkToolbar: "inquiry-bulk-toolbar",
  bulkMarkReplied: "inquiry-bulk-mark-replied",
  bulkSetStatus: "inquiry-bulk-set-status",
  bulkSelectAll: "inquiry-bulk-select-all",
  autoMatchBadge: "inquiry-auto-match-badge",
};

export const PIPELINE = {
  board: "pipeline-board",
  column: (stage) => `pipeline-column-${stage.replace(/\s+/g, "-").toLowerCase()}`,
  card: (id) => `pipeline-card-${id}`,
};

export const PRODUCT = {
  grid: "product-grid",
  addButton: "product-add-button",
  seedButton: "product-seed-button",
  card: (id) => `product-card-${id}`,
  createDialog: "product-create-dialog",
  createName: "product-create-name",
  createFabric: "product-create-fabric",
  createPrice: "product-create-price",
  createAvailability: "product-create-availability",
  createPhotoUrl: "product-create-photo-url",
  createPhotoUpload: "product-create-photo-upload",
  createColorTags: "product-create-color-tags",
  createMotifTags: "product-create-motif-tags",
  createSubmit: "product-create-submit",
};

export const MATCH = {
  uploadZone: "match-upload-zone",
  urlInput: "match-url-input",
  urlSubmit: "match-url-submit",
  budgetInput: "match-budget-input",
  availabilityFilter: "match-availability-filter",
  results: "match-results",
  resultCard: (id) => `match-result-${id}`,
  history: "match-history",
  historyRow: (id) => `match-history-${id}`,
  historyMarkSent: (id) => `match-history-sent-${id}`,
};

export const INVOICE = {
  panel: "invoice-panel",
  addItemSelect: "invoice-add-item-select",
  qtyInput: "invoice-qty-input",
  addItemButton: "invoice-add-item-button",
  itemRow: (id) => `invoice-line-${id}`,
  removeItem: (id) => `invoice-line-remove-${id}`,
  juspayInput: "invoice-juspay-input",
  juspaySave: "invoice-juspay-save",
  generateButton: "invoice-generate-button",
};

export const REPORT = {
  page: "report-page",
  conversionByType: "report-conversion-by-type",
  avgResponse: "report-avg-response",
  followupRate: "report-followup-rate",
  matchRate: "report-match-rate",
  lostSlow: "report-lost-slow",
};

export const IG_LOOKUP = {
  section: "ig-lookup-section",
  urlInput: "ig-lookup-url",
  submit: "ig-lookup-submit",
  results: "ig-lookup-results",
  thumb: (i) => `ig-lookup-thumb-${i}`,
};

export const BROADCAST = {
  openButton: (id) => `broadcast-open-${id}`,
  dialog: "broadcast-dialog",
  captionInput: "broadcast-caption",
  recipientRow: (id) => `broadcast-recipient-${id}`,
  selectAll: "broadcast-select-all",
  submit: "broadcast-submit",
  historyPanel: "broadcast-history",
};

export const TIMELINE = {
  card: (id) => `timeline-card-${id}`,
  startButton: (id) => `timeline-start-${id}`,
  clearButton: (id) => `timeline-clear-${id}`,
  bar: (id) => `timeline-bar-${id}`,
};

export const SLA = {
  banner: "sla-nudge-banner",
  count: "sla-nudge-count",
  dismiss: "sla-nudge-dismiss",
};
